import * as React from "react";
import { Box, Typography, Button, Divider, IconButton } from "@mui/material";
import Header from "../../components/global/Header";
import {
  getCurrentPlan,
  billingHistory,
  changeCurrentPlan,
} from "../../data/PricingData";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import secureLocalStorage from "react-secure-storage";

function ManageSubscription({ isSubscribe }) {
  const currentPlan = getCurrentPlan();
  const navigate = useNavigate();
  const handleClose = () => {
    navigate(-1);
  };

  const onPlanChange = () => {
    const res = changeCurrentPlan(currentPlan);
    console.log("res", res);
    if (res) {
      navigate("/subscriber/plan/change");
    }
  };
  const onCancel = () => {
    secureLocalStorage.setItem("cancelSubscription", true);

    navigate("/subscriber");
  };

  return (
    <>
      {isSubscribe == true ? (
        <Box m={"2vw"}>
          <Header title={"Manage Subscription"} />

          <Box p={4} margin="auto" backgroundColor="#201939">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="h5"
                color="var(--white)"
                mb={2}
                fontWeight={600}
              >
                Subscription Details
              </Typography>
              <IconButton
                edge="end"
                onClick={handleClose}
                style={{
                  borderRadius: "0.3vw",
                  color: "var(--white)",
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>

            <Typography variant="body1" color="var(--white)" mb={2}>
              Current Plan:
              <span
                style={{ color: "var(--color-white-50)", paddingLeft: "0.4vw" }}
              >
                {currentPlan.title}
              </span>
              <br />
              Plan Amount:
              <span
                style={{ color: "var(--color-white-50)", paddingLeft: "0.4vw" }}
              >
                ${currentPlan.price}
              </span>
            </Typography>

            <Divider style={{ background: "var(--color-white-50)" }} />

            <Typography
              variant="h5"
              color="var(--white)"
              my={2}
              fontWeight={600}
            >
              Billing Details
            </Typography>
            <Box>
              <Typography variant="body1" color="var(--white)" mb={2}>
                Date:
                <span
                  style={{
                    color: "var(--color-white-50)",
                    paddingLeft: "0.4vw",
                  }}
                >
                  {billingHistory.date}
                </span>
                <br />
                Status:
                <span
                  style={{
                    color: "var(--color-white-50)",
                    paddingLeft: "0.4vw",
                  }}
                >
                  $ {billingHistory.status}
                </span>
              </Typography>

              <Divider />
            </Box>

            <Divider style={{ background: "var(--color-white-50)" }} />

            <Box mt={4}>
              <Button
                variant="contained"
                sx={{ marginRight: 2 }}
                onClick={onPlanChange}
              >
                Change Plan
              </Button>
              <Button
                variant="contained"
                style={{
                  background: "var(--color-maroon)",
                }}
                onClick={onCancel}
              >
                Cancel Subscription
              </Button>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box m="2vw">
          <Header subTitle="No Access" />
        </Box>
      )}
    </>
  );
}

export default ManageSubscription;
